import { Checkbox } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext, FieldValues, FieldPath } from "react-hook-form"
import type { CheckboxFieldProps } from "./CheckboxField.types"

export function CheckboxField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  disabled,
  children,
}: CheckboxFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
      valuePropName="checked"
    >
      <Checkbox disabled={disabled}>{children}</Checkbox>
    </FormItem>
  )
}
